import { z } from "zod";

export const TheatreLayout = z.object({
  ID: z.number(),
  Name: z.string(),
  Description: z.string().optional(),
  Barcode: z.string(),
  created: z.number().optional(), // local value
});

export type ITheatreLayout = z.infer<typeof TheatreLayout>;

export type GetByBarcodeRequest = {
  barcodeWithoutChecksum: string;
};
